module.exports = __webpack_public_path__ + "img/blog-img.87b33d35.svg";